'use client';
import { useMutation, useSuspenseQuery } from '@tanstack/react-query';
import { ORDER_QUERIES } from '../../infrastructure/order/utils/queries';
import type {
  GetOrderRequest,
  GetUserOrdersRequest,
  AssociateOrderRequest,
  AssociateOrderResponse,
} from '../../infrastructure/order/utils/types';

export const useOrderService = () => {
  const useGetOrder = (params: GetOrderRequest) => {
    return useSuspenseQuery(ORDER_QUERIES.getOrder(params));
  };

  const useGetUserOrders = (params: GetUserOrdersRequest) => {
    return useSuspenseQuery(ORDER_QUERIES.getUserOrders(params));
  };

  const useAssociateOrder = () => {
    return useMutation(ORDER_QUERIES.associateOrder());
  };

  return {
    useGetOrder,
    useGetUserOrders,
    useAssociateOrder,
  };
};
